/**
 * Keeps the theme "search empty state" block in sync with Searchanise, which loads results asynchronously.
 */
function syncSearchEmptyState() {
  const section = document.querySelector('[data-search-empty-state]');
  if (!section) return;

  const q = new URLSearchParams(window.location.search).get('q');
  console.log(q);
  const hasQuery = q !== null && String(q).trim().length > 0;
  const snizeRoot = document.getElementById('snize_results');

  if (!hasQuery) {
    section.classList.remove('search-empty-state--visible');
    snizeRoot?.classList.remove('search-empty-state-snize--hide-default');
    return;
  }

  if (!snizeRoot) return;

  if (snizeRoot.querySelector('#snize_skeleton_results')) return;

  const productCount = snizeRoot.querySelectorAll('li.snize-product').length;
  if (productCount === 0) {
    section.classList.add('search-empty-state--visible');
    snizeRoot.classList.add('search-empty-state-snize--hide-default');
  } else {
    section.classList.remove('search-empty-state--visible');
    snizeRoot.classList.remove('search-empty-state-snize--hide-default');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  syncSearchEmptyState();
  const snizeRoot = document.getElementById('snize_results');
  if (!snizeRoot) return;

  const observer = new MutationObserver(() => {
    syncSearchEmptyState();
  });
  observer.observe(snizeRoot, { childList: true, subtree: true });

  [500, 2000, 5000].forEach((ms) => setTimeout(syncSearchEmptyState, ms));
});
